<template>
  <v-dialog v-model="open"
            :max-width="maxWidth"
            :min-height="minHeight"
            :fullscreen="$vuetify.breakpoint.xsOnly"
            :persistent="!notPersistent"
            :scrollable="!notScrollable"
            @keydown.escape.capture.stop="onClose">
    <template v-slot:activator="_scope">
      <slot name="activator"
            :open="onOpen" />
    </template>
    <v-card class="rounded-lg px-3 py-5"
            elevation="0">
      <v-toolbar dense
                 flat
                 :height="toolbarHeight"
                 color="toolbar-bg">
        <slot name="beforeTitle" />
        <v-toolbar-title class="font-weight-medium">
          <slot name="title">
            {{title}}
          </slot>
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon
               @click="onClose">
          <v-icon color="text--disabled">
            mdi-close
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pa-4 text--primary"
                   :style="cardStyle">
        <slot />
      </v-card-text>
      <v-card-actions v-if="$scopedSlots && $scopedSlots.actions"
                      class="pt-0">
        <slot name="actions"
              :close="onClose" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogWrapper',
  props: {
    notPersistent: {
      type: Boolean,
      default: false,
    },
    notScrollable: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: undefined,
    },
    value: {
      type: [Boolean],
      default: undefined,
    },
    maxWidth: {
      type: String,
      default: '600px',
    },
    minHeight: {
      type: String,
      default: undefined,
    },
    toolbarHeight: {
      type: String,
      default: undefined,
    },
  },
  emits: ['open', 'close', 'input'],
  data () {
    return {
      internalOpen: false,
    };
  },
  computed: {
    open: {
      get () {
        return this.value !== undefined ? this.value : this.internalOpen;
      },
      set (value) {
        this.$emit('input', value);
        this.internalOpen = value;
      },
    },
    cardStyle () {
      const style = {};
      if (this.minHeight) {
        style['min-height'] = this.minHeight;
      }
      return style;
    },
  },
  methods: {
    onOpen () {
      this.open = true;
      this.$emit('open');
    },
    close () {
      this.onClose();
    },
    onClose () {
      this.open = false;
      this.$emit('close');
    },
  },
};
</script>

<style>
.v-dialog {
  box-shadow: none!important;
}
</style>
